export default __webpack_public_path__ + "static/flat-6268923586945905b77fa5c424020980.png";